


(function ($) {
    'use strict';
    $(function () {

        const gallerySwiper = new Swiper('.js-gallery-swiper', {
            slidesPerView: 5.3,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: ".js-gallery-swiper-next",
                prevEl: ".js-gallery-swiper-prev",
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1.3,
                },
                635: {
                    slidesPerView: 2.3,
                },
                768: {
                    slidesPerView: 3.3,
                },

                992: {
                    spaceBetween: 16,
                    slidesPerView: 4.3,
                }
            }

        });



    });
})(jQuery);
